<template>
    <h2 class="text-main mb-2">
        <slot />
    </h2>
</template>
